<script setup lang="ts">
import InformationBaseCard from '@/components/Cards/InformationBaseCard.vue'
import { StackLayout } from '@/components/Layouts'
import { TypographyWithPrefix } from '@/components/Typography'

type Props = {
    organizationName?: string
}
defineProps<Props>()
</script>

<template>
    <InformationBaseCard class="full-width" :label="$t('user.create.organizationTitle')">
        <StackLayout :gap="8" class="full-width" isResponsiveSmallScreen>
            <TypographyWithPrefix
                :prefix="$t('user.detail.organizationTitle')"
                :label="organizationName"
                class="full-width" />
        </StackLayout>
    </InformationBaseCard>
</template>
